import {
  Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, Typography
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import PropTypes from 'prop-types';

// Pasos en orden: es una secuencia real (se guarda → se crea el servicio → se retoma el borrador)
const PASOS = [
  'Guardamos tu página como borrador, con todo lo que llevas escrito.',
  'Creas tu servicio en el formulario que sigue.',
  <>
    Para retomar tu página entra a <b>Mis servicios → Página de servicios → Borradores</b> y
    pulsa <b>Editar</b>. Ahí podrás agregarle el servicio nuevo.
  </>,
];

// Avisa que "Crear un nuevo servicio" saca del formulario de la página y que lo escrito queda
// guardado como borrador, para que nadie crea que lo perdió y lo rehaga.
const ModalBorradorPagina = ({ open, onClose, onConfirm, guardando, error, publicada }) => (
  <Dialog
    open={open}
    onClose={guardando ? undefined : onClose}
    fullWidth
    maxWidth="sm"
    aria-labelledby="titulo-modal-borrador"
  >
    <DialogContent sx={{ pt: 4 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', mb: 3 }}>
        <Box
          sx={{
            width: 64, height: 64, borderRadius: '50%', mb: 2, color: 'primary.main',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            bgcolor: (tema) => alpha(tema.palette.secondary.main, 0.15),
          }}
        >
          <EditNoteOutlinedIcon fontSize="large" />
        </Box>
        <Typography id="titulo-modal-borrador" variant="h5" color="primary" fontWeight="bold" gutterBottom>
          Tu página se guardará como borrador
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Para crear un servicio te llevamos a otro formulario. <b>No pierdes nada:</b> todo lo
          que llevas escrito queda guardado.
        </Typography>
      </Box>

      <Box component="ol" sx={{ m: 0, pl: 3, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {PASOS.map((paso, i) => (
          <Typography key={i} component="li" variant="body2" color="primary">{paso}</Typography>
        ))}
      </Box>

      {publicada && (
        <Alert severity="warning" sx={{ mt: 3 }}>
          Tu página ya está publicada. Al guardarla como borrador dejará de verse en la
          plataforma hasta que la vuelvas a publicar.
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          No pudimos guardar el borrador. Revisa tu conexión e intenta de nuevo.
        </Alert>
      )}
    </DialogContent>

    <DialogActions sx={{ px: 3, pb: 3, gap: 1, flexWrap: 'wrap' }}>
      <Button type="button" variant="outlined" onClick={onClose} disabled={guardando}>
        Seguir editando aquí
      </Button>
      <Button
        type="button"
        variant="contained"
        onClick={onConfirm}
        disabled={guardando}
        startIcon={guardando ? <CircularProgress size={18} color="inherit" /> : null}
      >
        {guardando ? 'Guardando...' : 'Guardar borrador y continuar'}
      </Button>
    </DialogActions>
  </Dialog>
);

ModalBorradorPagina.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  guardando: PropTypes.bool,
  error: PropTypes.bool,
  publicada: PropTypes.bool,
};

export default ModalBorradorPagina;
